import { render, staticRenderFns } from "./PedidosDiaDia.vue?vue&type=template&id=2705e61a&scoped=true"
import script from "./PedidosDiaDia.vue?vue&type=script&lang=js"
export * from "./PedidosDiaDia.vue?vue&type=script&lang=js"
import style0 from "./PedidosDiaDia.vue?vue&type=style&index=0&id=2705e61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705e61a",
  null
  
)

export default component.exports